export default __webpack_public_path__ + "static/media/fad-phase.abd31678.svg";